import FullModalAside from './FullModalAside';
export default FullModalAside;
